export default "__VITE_ASSET__8edpRspu__"